<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.4" cx="9.99994" cy="10" r="10" fill="var(--primary)" />
    <circle cx="9.99994" cy="10" r="8" fill="var(--primary)" />
    <path
      d="M7.704 14.06C7.552 14.06 7.424 14.008 7.32 13.904C7.216 13.8 7.164 13.672 7.164 13.52V6.17602C7.164 6.02402 7.216 5.89602 7.32 5.79202C7.424 5.68002 7.552 5.62402 7.704 5.62402H10.44C11.2 5.62402 11.82 5.75202 12.3 6.00802C12.78 6.26402 13.124 6.59202 13.332 6.99202C13.54 7.39202 13.644 7.82402 13.644 8.28802C13.644 8.75202 13.54 9.18402 13.332 9.58402C13.124 9.98402 12.78 10.312 12.3 10.568C11.82 10.824 11.2 10.952 10.44 10.952H8.256V13.52C8.256 13.672 8.2 13.8 8.088 13.904C7.984 14.008 7.856 14.06 7.704 14.06ZM10.332 9.92002C11.148 9.92002 11.72 9.76402 12.048 9.45202C12.384 9.14002 12.552 8.75202 12.552 8.28802C12.552 7.82402 12.384 7.43602 12.048 7.12402C11.72 6.81202 11.148 6.65602 10.332 6.65602H8.256V9.92002H10.332Z"
      fill="white"
      stroke="white"
      stroke-width="0.6"
    />
  </svg>
</template>

<script>
export default {
  name: "PointsIcon",
};
</script>

<style>
</style>
